import { httpV2 } from "../http.js";

const ZonesService = {
  getZones: (filters) =>
    httpV2.get(`/zones?${new URLSearchParams(filters).toString()}`),
  getZoneGroups: (group) => httpV2.get(`/zones/groups/${group}`),
  toggleGroupItem: (zone, item_type, item_id) =>
    httpV2.post(`/zones/toggle/${zone.id}/${item_type}/${item_id}`),
  getZone: (id) => httpV2.get(`/zones/${id}`),
  createZone: (item) => httpV2.post(`/zones`, item),
  editZone: (item) => httpV2.put(`/zones/${item.id}`, item),
  removeZone: (item) => httpV2.delete(`/zones/${item.id}`),
};

export default ZonesService;
